import { UnitRangeSlider as AntdUnitRangeSlider } from "@empglabs/backoffice-ui-kit"

const UnitRangeSlider = props => {
  return <AntdUnitRangeSlider {...props} />
}

export default UnitRangeSlider
